<!-- uploader-dialog.component.html -->
<div class="mat-typography uploader-dialog">
  <frmg-uploader
    [projectId]="data.projectId"
    [folderName]="data.folderName"
    [tenantId]="data.tenantId"
    [teamId]="data.teamId"
    [userId]="data.userId"
    (closeMenu)="close()"
  ></frmg-uploader>
</div>
